import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { DashboardService } from '../dashboard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-register-dgusers-device-byadmin',
  templateUrl: './register-dgusers-device-byadmin.component.html',
  styleUrls: ['./register-dgusers-device-byadmin.component.scss']
})
export class RegisterDgusersDeviceByadminComponent implements OnInit {

  private ResponseVerifiedGetAllSubDevice: Subject<any> = new Subject();
  private ResponseVerifiedGetAllEnergyMeter: Subject<any> = new Subject();
  public userId: any;
  public registrationForm: FormGroup;
  public subDeviceList: FormArray;
  sensorList: FormArray;
  public roleName: string;
  public role: any;
  public subDevice: any;
  public devices: any;
  public epc_id: any;
  public masterDeviceObj: {};
  public normalUserDeviceList: any = [];
  public deviceObject: { user_id: any; };
  public sub_device: boolean;
  public wmsFlag: boolean = false;
  public model_id: any;
  public sensorDataList: any[];
  public isSelected: boolean = false;
  public isNewDevice: boolean = false;
  public SubDevice_Id: string;
  public isEditDevice: boolean = true;
  public demo: any;
  public sub_device_information: any = [];
  public meterType: any = [];
  public meter_type_Id: any;
  is_emeter: any;
  is_wms:any;
  deviceEditObject: { user_id: any; device_info: any; };
  public DGDataList: any[];

  constructor(private fb: FormBuilder, private dasbordService: DashboardService, private router: Router, private route: ActivatedRoute, private toastr: ToastrService, private modalService1: NgbModal) {

    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }

    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.userId = params.id;
        this.epc_id = params.epc_id;
        this.is_emeter = params.is_emeter;
        this.is_wms = params.is_wms;
      }
    });
  }

  ngOnInit() {

    this.getAllMeterType();
    this.registrationForm = this.fb.group({
      device_id: ['', Validators.required],
      device_index: [null, Validators.required],
      device_name: [null, Validators.compose([Validators.required])],
      sub_device_info: this.fb.array([])
    });

    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllSubDevice();
      this.getAllDevices();
      this.getDeviceForWmsUser(this.userId);

      this.getAllWmsSensorList();
      this.getAllDGSensorList();
    
    }

  }
  get f() { return this.registrationForm.controls; }

  public showModal(StringPopup) {
    this.modalService1.open(StringPopup, {
      size: <any>'xl', backdrop: 'static',
      keyboard: false
    });
  }
  // subdevice form
  addSub_device() {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    this.subDeviceList.push(this.fb.group({
      sub_device_type_id: ['', Validators.compose([Validators.required])],   // it has model id
      model_id: ['', Validators.compose([Validators.required])],
      //addition for meter type
      meter_type_id: [null, Validators.compose([Validators.required])],// model type added  for wms energy meter
      meter_slug: [null],// if required
      // dg_rating: [null,Validators.compose([Validators.required])],
      installed_capacity: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")])],
      spec: [null, [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      name: [null, [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      sub_device_id: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])],     // it has model id
      id: [null, Validators.compose([Validators.required])],
      subdevice_index: [null, Validators.compose([Validators.required])],
      connected_solar_capacity: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")])],
      isRemoveSubDevice: [null, Validators.compose([Validators.required])],
      sensor_info: this.fb.array([])
    }));
    if (this.subDeviceList.length > 0) {
      this.sub_device = true
    } else {
      this.sub_device = false
    }
    this.wmsFlag = false;

    console.log("addition of sub device")
    console.log(this.subDeviceList)
  }

  // sensor form
  add_sensor(i) {
    this.sensorList = (this.registrationForm.controls['sub_device_info'] as FormArray).at(i).get('sensor_info') as FormArray;
    this.sensorList.push(this.fb.group({
      sensor_id: ['', [Validators.required]],
      param_no: [null, [Validators.required, this.parmNumberValidator]],
      gain: [null],
      reminder: [null],
      dg_rating: [null],
      dg_model_name: [null],
      id: [null, [Validators.required]],
      sensor_index: [null, [Validators.required]],
      isRemoveSensor: [null, [Validators.required]],
    }));
  }

  // custom validation for sensor
  parmNumberValidator(control: AbstractControl)
    : { [key: string]: any } | null {
    const valid = (control.value >= 1 && control.value <= 40)
    return valid
      ? null
      : { invalidNumber: { valid: false, value: control.value } }
  }

  get sub_deviceFormGroup() {
    return this.registrationForm.get('sub_device_info') as FormArray;
  }

  // on change model
  onChangeSubDeviceModel(value) {
    this.model_id = value
  }

  onChangeSensor(value, controls, index,callBy:String) {
    // this.sensor_id = value
    if(callBy == 'dg'){
      let data=  this.registrationForm.value.sub_device_info.filter(item => item.sub_device_type_id == '5' && !item.isRemoveSubDevice)
      if(this.areSensorIdsUnique(data)){
        controls["sensor_id"].setErrors({ sensorSelected: true }); 
      }
    }else if(callBy == 'sensor'){
      let data=  this.registrationForm.value.sub_device_info.filter(item => item.sub_device_type_id == '2' && !item.isRemoveSubDevice)
      if(this.areSensorIdsUnique(data)){
        controls["sensor_id"].setErrors({ sensorSelected: true }); 
      }
      }
  }
  areSensorIdsUnique(data) {
    const seenIds = new Set();
    // Iterate over each item in the outer array
    for (const item of data) {
      // Iterate over each sensor_info array inside the item
      for (const sensor of item.sensor_info) {
        if (seenIds.has(sensor.sensor_id)) {
          // If the ID is already seen, return true (duplicate found)
          return true;
        }
        // Add the sensor ID to the Set
        if(!sensor.isRemoveSensor){
          seenIds.add(sensor.sensor_id);
        }
     
      }
    }
    // If no duplicates were found, return false
    return false;
  }

  // on change subdevice
  onChangeSubDevice(value, i, controls) {
    this.SubDevice_Id = value;
    if (value == '5' || value == '2' ) {
      controls.installed_capacity.reset();
      controls.spec.reset();
      controls.connected_solar_capacity.reset();

      this.registrationForm.value.sub_device_info.forEach((element,index) => {
        if(!element.isRemoveSubDevice && element.sub_device_type_id == value && (element.sub_device_type_id == '5' || element.sub_device_type_id == '2') && i !=index ){
          controls["sub_device_type_id"].setErrors({ deviceSelected: true });
        }
      });

   /*  if(value == '5'){
      // dg
      this.getAllDGSensorList();
      this.sensorList.controls['gain'].clearValidators();
      this.sensorList.controls['reminder'].clearValidators();
      this.sensorList.controls['gain'].updateValueAndValidity();
      this.sensorList.controls['reminder'].updateValueAndValidity();



      // this.sensorList.removeControl('reason');
      // this.registrationForm.controls.sub_device_info.controls[0].controls.sensor_info.controls[0].controls.gain

      // this.registrationForm.get('sub_device_info')['controls'].controls.sensor_info.controls[0].controls.gain
      // return (this.registrationForm.get('gain') as FormArray).controls;

      // this.sensorList.controls['gain'].clearValidators();
      // this.sensorList.controls['reminder'].clearValidators();
      // this.sensorList.controls['gain'].updateValueAndValidity();
      // this.sensorList.controls['reminder'].updateValueAndValidity();
    } else if(value == '2'){
      // wms
      this.getAllWmsSensorList();
      this.sensorList.controls['dg_rating'].clearValidators();
      this.sensorList.controls['dg_model_name'].clearValidators();
      this.sensorList.controls['dg_rating'].updateValueAndValidity();
      this.sensorList.controls['dg_model_name'].updateValueAndValidity()


      // console.log(this.sensorList);
      // this.sensorList[0].removeControl("gain");
      // this.add_sensor(i).controls[i].get('dg_rating').clearValidators();
      // this.registrationForm.controls.sub_device_info.controls.controls.get('dg_model_name').setValidators(null);
      // this.registrationForm.controls.sub_device_info.get('dg_rating').setValidators(null);
      // this.registrationForm.controls.sub_device_info.get('dg_model_name').updateValueAndValidity();
      // this.registrationForm.controls.sub_device_info.get('dg_rating').updateValueAndValidity();
    } */
  }
    // else if (value == '1') {
    //   controls.meter_type_id.reset();
    // }
    else {
      this.wmsFlag = false;
    }

  }
  onEditChange(value) {
    this.isNewDevice = true;
    var d = this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id);
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    if (this.subDeviceList.length > 0 && this.normalUserDeviceList.find(x => x.device_id == value)) {
      for (let i = this.subDeviceList.length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
        //  this.addSub_device();
      }
      this.toastr.success("Device is Allready Selected Please Select Other Device");
    } else if (this.subDeviceList.length > 0 && value == "") {
      for (let i = this.subDeviceList.length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
        //  this.addSub_device();
      }
    }
    else if (d == undefined && value != d && value != "") {
      if (this.subDeviceList.length == 0) {
        this.addSub_device();
      }
    }
    else {
      this.toastr.success("Device is Allready Selected ");
      return false;
    }
  }
  // for drop down find the model
  getCriteria(type) {
    const select = this.subDevice.find(_ => _.sub_device_type_id == type);
    return select ? select.model_info : select;
  }

  // Get Sensors list for WMS users
  getAllWmsSensorList() {
    this.dasbordService.getAdminAllWmsSensorList()
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status) {
            this.sensorDataList = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              // this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.error(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  getAllDGSensorList() {
    this.dasbordService.getAdminAllDGSensorList()
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status) {
            this.DGDataList = data.resultObject;
            // console.log(this.DGDataList);
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              // this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.error(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get all Devices
  getAllDevices(): void {
    this.masterDeviceObj = {
      epc_id: this.epc_id,
    }
    this.dasbordService.getAllMasterDevices(this.masterDeviceObj)
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status) {
            this.devices = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  //  get all Sub Device
  getAllSubDevice() {
    this.dasbordService.getAllSubDeviceByAdmin()
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status) {
           this.subDevice = [];
           this.subDevice.push(data.resultObject[0]);
           if (this.is_emeter == 1 || this.is_emeter == "1") {
              this.subDevice.push(data.resultObject[2]);
            }
            if (this.is_wms == 1 || this.is_wms == "1") {
              this.subDevice.push(data.resultObject[1]);
            }
            this.subDevice.push(data.resultObject[4]);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get multiple devices Wmsuser by Id
  getDeviceForWmsUser(userId) {
    this.deviceObject = {
      user_id: userId,
    }
    this.dasbordService.getAdminDgUserDevicesById(this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status) {
            this.normalUserDeviceList = data.device_info;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  updateDeviceById() {
    console.log("dg rating")
    console.log( this.normalUserDeviceList)
    this.deviceEditObject = {
      user_id: this.userId,
      device_info: this.normalUserDeviceList
    }
    this.dasbordService.updateDeviceForDgUserByAdmin(this.deviceEditObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllSubDevice))
      .subscribe(
        async data => {
          if (data.status === true || data.status === 'true') {
            this.toastr.success("Device Updated Successfully")
            this.router.navigate(['/inject-solar/admin-user-registration/admin-dg-users']);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // edit device method
  EditDevice(device_id, index) {
    // if(this.subDeviceList.length == 0){
    //   this.EditCancel();
    // }
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    if (this.isEditDevice == true && this.subDeviceList.length == 0) {
      this.isSelected = true;
      var dev = this.normalUserDeviceList.find(x => x.device_id == device_id).dev_name;
      var subDevLength = this.normalUserDeviceList.find(x => x.device_id == device_id).sub_device_info;
      this.registrationForm.get('device_name').setValue(dev);
      this.registrationForm.get('device_id').setValue(device_id);
      this.registrationForm.get('device_index').setValue(index);
      for (var i = 0; i < subDevLength.length; i++) {
        this.addSub_device();
        if (subDevLength[i].sensor_info.length != 0) {
          for (let j = 0; j < subDevLength[i].sensor_info.length; j++)
            this.add_sensor(i)
        }
      }
      this.registrationForm.patchValue({
        sub_device_info: subDevLength
      })
      this.isEditDevice = false
    } else {
      this.toastr.info("Please Click Save Device or Cancel Device");
    }
  }

  removeEditDevice(index, device_id) {
    var dev = this.normalUserDeviceList.find(x => x.device_id == device_id);
    if (this.normalUserDeviceList.find(x => x.device_id == device_id).isNewDevice == false) {
      this.normalUserDeviceList.find(x => x.device_id == device_id).isRemoveDevice = true;
    }
    else {
      this.normalUserDeviceList.splice(index, 1);
    }
    this.registrationForm.reset();
    this.EditCancel();
    this.sub_device = false;
  }

  EditCancel() {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    length = this.subDeviceList.length;
    if (length > 0) {
      for (let i = length - 1; i >= 0; i--) {
        this.subDeviceList.removeAt(i)
      }
    }
    this.isSelected = false;
    this.isNewDevice = false;
    this.isEditDevice = true;
    this.sub_device = false;
    this.registrationForm.reset();
  }

  validInverter() {
    this.sub_device_information = this.registrationForm.value.sub_device_info;
    for (let i = 0; i < this.sub_device_information.length; i++) {
      // if ((this.sub_device_information[i].sub_device_type_id == '' || this.sub_device_information[i].model_id == '' || this.sub_device_information[i].installed_capacity == null || this.sub_device_information[i].installed_capacity == '' || this.sub_device_information[i].spec == null || this.sub_device_information[i].spec == '' || this.sub_device_information[i].name == null || this.sub_device_information[i].name == "" || this.sub_device_information[i].sub_device_id == null || this.sub_device_information[i].connected_solar_capacity == null || this.sub_device_information[i].sub_device_id == "") && (this.sub_device_information[i].sub_device_type_id != '2')) {
        if ((this.sub_device_information[i].sub_device_type_id == '' || this.sub_device_information[i].model_id == '' || this.sub_device_information[i].installed_capacity == null || this.sub_device_information[i].installed_capacity == '' || this.sub_device_information[i].spec == null || this.sub_device_information[i].spec == '' || this.sub_device_information[i].name == null || this.sub_device_information[i].name == "" || this.sub_device_information[i].sub_device_id == null || this.sub_device_information[i].connected_solar_capacity == null || this.sub_device_information[i].sub_device_id == "") && (this.sub_device_information[i].sub_device_type_id == '1')) {
      return true
      } else {
        return false
      }
    }
  }

  validwms() {
    this.sub_device_information = this.registrationForm.value.sub_device_info;
    for (let i = 0; i < this.sub_device_information.length; i++) {
      if ((this.sub_device_information[i].sub_device_type_id == '' || this.sub_device_information[i].model_id == '' || this.sub_device_information[i].name == null || this.sub_device_information[i].name == "" || this.sub_device_information[i].sub_device_id == null || this.sub_device_information[i].sub_device_id == "") && (this.sub_device_information[i].sub_device_type_id == '2')) {
        return true
      } else {
        return false
      }
    }
  }

  validEnergyMeter() {
    this.sub_device_information = this.registrationForm.value.sub_device_info;
    for (let i = 0; i < this.sub_device_information.length; i++) {
      if ((this.sub_device_information[i].sub_device_type_id == '' || this.sub_device_information[i].meter_type_id == '' || this.sub_device_information[i].name == null || this.sub_device_information[i].name == "" || this.sub_device_information[i].sub_device_id == null || this.sub_device_information[i].sub_device_id == "") && (this.sub_device_information[i].sub_device_type_id == '3')) {
        return true
      } else {
        return false
      }
    }
  }

  submitEdit() {
    // console.log(this.registrationForm.controls.value);
    // console.log(this.SubDevice_Id)
    this.sub_device_information = this.registrationForm.value.sub_device_info;
    if (this.validInverter() || this.registrationForm.value.device_id == '') {
      this.toastr.info("Please fill the all Field of Inverter");
    } else if (this.validwms() || this.registrationForm.value.device_id == '') {
      this.toastr.info("Please fill the all Field of wms");
    } 
    // else if (this.sub_device_information.find(subDevice => subDevice.sensor_info.some(item => item.sensor_id === null || item.param_no == null || item.gain == null || item.sensor_id === "" || item.param_no == "" || item.gain == ""|| item.reminder == ""|| item.reminder == null))) {
      // Hide the remainder 

        // TEMP HIDE VALIDATION CODE R
   /*  // dg value = 5
     else if (this.SubDevice_Id=='5' && this.sub_device_information.find(subDevice => subDevice.sensor_info.some(item => item.sensor_id === null || item.param_no == null || item.dg_rating == null || item.dg_model_name == null || item.sensor_id === "" || item.param_no == "" || item.dg_rating == "" || item.dg_model_name == "" ))) {
    
      this.toastr.info("Please fill the all Field of DG");
      //else if for energy meter
    }
   
    // wms value = 2
    else if(this.SubDevice_Id=='2' && this.sub_device_information.find(subDevice => subDevice.sensor_info.some(item => item.sensor_id === null || item.param_no == null ||  item.sensor_id === "" || item.param_no == "" ||  item.gain == ""|| item.reminder == "" ||  item.gain == null || item.reminder == null))){
      this.toastr.info("Please fill the all Field of Sensor");
    } */

    else if (this.validEnergyMeter() || this.registrationForm.value.device_id == '') {
      this.toastr.info("Please fill the all Field of energy meter");
      //else if for energy meter
    }
    else {
      if (this.isNewDevice == false) {
        //Update already Exist Device with new or old sub device
        var device_info = this.registrationForm.value
        for (let i = 0; i < this.normalUserDeviceList.length; i++) {
          if (this.normalUserDeviceList[i].device_id == device_info.device_id) {
            for (let j = 0; j < this.registrationForm.value.sub_device_info.length; j++) {
              if (this.registrationForm.value.sub_device_info[j].id != null) {
                for (let e = 0; e < this.normalUserDeviceList[i].sub_device_info.length; e++) {
                  if (this.normalUserDeviceList[i].sub_device_info[e].id != 0 && this.normalUserDeviceList[i].sub_device_info[e].id == this.registrationForm.value.sub_device_info[j].id) {
                    this.normalUserDeviceList[i].sub_device_info[e].installed_capacity = this.registrationForm.value.sub_device_info[j].installed_capacity;
                    this.normalUserDeviceList[i].sub_device_info[e].name = this.registrationForm.value.sub_device_info[j].name;
                    // this.normalUserDeviceList[i].sub_device_info[e].dg_rating = this.registrationForm.value.sub_device_info[j].dg_rating;
                    this.normalUserDeviceList[i].sub_device_info[e].spec = this.registrationForm.value.sub_device_info[j].spec;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_type_id = this.registrationForm.value.sub_device_info[j].sub_device_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].model_id = this.registrationForm.value.sub_device_info[j].model_id;
                    // addition for meter type
                    this.normalUserDeviceList[i].sub_device_info[e].meter_type_id = this.registrationForm.value.sub_device_info[j].meter_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_id = this.registrationForm.value.sub_device_info[j].sub_device_id;
                    this.normalUserDeviceList[i].sub_device_info[e].connected_solar_capacity = this.registrationForm.value.sub_device_info[j].connected_solar_capacity;

                    // push Inverter Name

                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    //push dg rating
                    // for (var y = 0; y < this.subDevice.length; y++) {
                    //   if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    //     this.normalUserDeviceList[i].sub_device_info[e].dg_rating = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).dg_rating;
                    //   }
                    // }
                    // // push meter_slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].name) {
                        this.normalUserDeviceList[i].sub_device_info[e].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].name).name;
                      }
                    }
                    // push meter type id
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                    // push model name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                    // push energy meter
                    for (let k = 0; k < this.registrationForm.value.sub_device_info[j].sensor_info.length; k++) {
                      if (this.registrationForm.value.sub_device_info[j].sensor_info[k].id != null) {
                        for (let p = 0; p < this.normalUserDeviceList[i].sub_device_info[e].sensor_info.length; p++) {
                          if (this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id != 0 && this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].id) {
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_id = this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].param_no = this.registrationForm.value.sub_device_info[j].sensor_info[k].param_no;;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].gain = this.registrationForm.value.sub_device_info[j].sensor_info[k].gain;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].reminder = this.registrationForm.value.sub_device_info[j].sensor_info[k].reminder;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_rating = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_rating;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_model_name = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_model_name;
                            //this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].isRemoveSensor = false;
                            if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                              for (var x = 0; x < this.sensorDataList.length; x++) {
                                if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList[x].sensor_name;
                                }
                              }
                            } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                              for (var x = 0; x < this.DGDataList.length; x++) {
                                if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.DGDataList[x].sensor_name;
                               
                                }
                              }
                            }
                            // for (var x = 0; x < this.sensorDataList.length; x++) {
                            //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                            //     this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                            //   }
                            // }
                          }
                          else if (this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id == 0 && this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_index == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_index) {
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_id = this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].param_no = this.registrationForm.value.sub_device_info[j].sensor_info[k].param_no;;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].gain = this.registrationForm.value.sub_device_info[j].sensor_info[k].gain;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].reminder = this.registrationForm.value.sub_device_info[j].sensor_info[k].reminder;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_rating = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_rating;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_model_name = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_model_name;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].isRemoveSensor = false;
                            //  push sensor name
                            if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                              for (var x = 0; x < this.sensorDataList.length; x++) {
                                if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList[x].sensor_name;
                                  // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                                }
                              }
                            }else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                              for (var x = 0; x < this.DGDataList.length; x++) {
                                if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.DGDataList[x].sensor_name;
                                  // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                                }
                              }
                            }
                           
                          }
                        }
                      } else {    //Push new sensor info
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info.push(this.registrationForm.value.sub_device_info[j].sensor_info[k]);
                        let curSensorIndex = this.normalUserDeviceList[i].sub_device_info[e].sensor_info.length - 1;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].id = 0;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensor_index = k;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].isRemoveSensor = false;
                        // push  Sensor Name
                        if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                          for (var x = 0; x < this.sensorDataList.length; x++) {
                            if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                              this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.sensorDataList[x].sensor_name;
                            }
                          }
                        } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                          for (var x = 0; x < this.DGDataList.length; x++) {
                            if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                              this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.DGDataList[x].sensor_name;
                              
                            }
                          }
                        }
                        // for (var x = 0; x < this.sensorDataList.length; x++) {
                        //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                        //     this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                        //   }
                        // }
                      }
                    }
                  }
                  else if (this.normalUserDeviceList[i].sub_device_info[e].id == 0 && this.normalUserDeviceList[i].sub_device_info[e].subdevice_index == this.registrationForm.value.sub_device_info[j].subdevice_index) {
                    this.normalUserDeviceList[i].sub_device_info[e].installed_capacity = this.registrationForm.value.sub_device_info[j].installed_capacity;
                    this.normalUserDeviceList[i].sub_device_info[e].name = this.registrationForm.value.sub_device_info[j].name;
                    this.normalUserDeviceList[i].sub_device_info[e].spec = this.registrationForm.value.sub_device_info[j].spec;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_type_id = this.registrationForm.value.sub_device_info[j].sub_device_type_id;
                    this.normalUserDeviceList[i].sub_device_info[e].model_id = this.registrationForm.value.sub_device_info[j].model_id;
                    // added meter name & slug
                    this.normalUserDeviceList[i].sub_device_info[e].meter_type_id = this.registrationForm.value.sub_device_info[j].meter_type_id;

                    this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.registrationForm.value.sub_device_info[j].meter_slug;
                    this.normalUserDeviceList[i].sub_device_info[e].sub_device_id = this.registrationForm.value.sub_device_info[j].sub_device_id;
                    this.normalUserDeviceList[i].sub_device_info[e].connected_solar_capacity = this.registrationForm.value.sub_device_info[j].connected_solar_capacity;
                    // this.normalUserDeviceList[i].sub_device_info[e].dg_rating = this.registrationForm.value.sub_device_info[j].dg_rating;
                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    // push model name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                    // push meter slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[e].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                     //push dg rating
                    //  for (var y = 0; y < this.subDevice.length; y++) {
                    //   if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    //     this.normalUserDeviceList[i].sub_device_info[e].dg_rating = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).dg_rating;
                    //   }
                    // }
                    // push meter name
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].name) {
                        this.normalUserDeviceList[i].sub_device_info[e].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].name).name;
                      }
                    }
                    for (let k = 0; k < this.registrationForm.value.sub_device_info[j].sensor_info.length; k++) {
                      if (this.registrationForm.value.sub_device_info[j].sensor_info[k].id != null) {
                        for (let p = 0; p < this.normalUserDeviceList[i].sub_device_info[e].sensor_info.length; p++) {
                          if (this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id != 0 && this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].id) {
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_id = this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].param_no = this.registrationForm.value.sub_device_info[j].sensor_info[k].param_no;;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].gain = this.registrationForm.value.sub_device_info[j].sensor_info[k].gain;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].reminder = this.registrationForm.value.sub_device_info[j].sensor_info[k].reminder;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_rating = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_rating;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_model_name = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_model_name;

                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].isRemoveSensor = false;
                            // push  Sensor Name
                            if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                              for (var x = 0; x < this.sensorDataList.length; x++) {
                                if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList[x].sensor_name;
                                }
                              }
                            } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                              for (var x = 0; x < this.DGDataList.length; x++) {
                                if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.DGDataList[x].sensor_name;
                                  
                                }
                              }
                            }
                            // for (var x = 0; x < this.sensorDataList.length; x++) {
                            //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                            //     this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                            //   }
                            // }
                          }
                          else if (this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].id == 0 && this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_index == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_index) {
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensor_id = this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].param_no = this.registrationForm.value.sub_device_info[j].sensor_info[k].param_no;;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].gain = this.registrationForm.value.sub_device_info[j].sensor_info[k].gain;
                            // this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].reminder = this.registrationForm.value.sub_device_info[j].sensor_info[k].reminder;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_rating = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_rating;
                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].dg_model_name = this.registrationForm.value.sub_device_info[j].sensor_info[k].dg_model_name;

                            this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].isRemoveSensor = false;
                            // push  Sensor Name
                            if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                              for (var x = 0; x < this.sensorDataList.length; x++) {
                                if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList[x].sensor_name;
                                }
                              }
                            } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                              for (var x = 0; x < this.DGDataList.length; x++) {
                                if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                                  this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.DGDataList[x].sensor_name;
                                  
                                }
                              }
                            }
                            // for (var x = 0; x < this.sensorDataList.length; x++) {
                            //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                            //     this.normalUserDeviceList[i].sub_device_info[e].sensor_info[p].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                            //   }
                            // }
                          }
                        }
                      } else {    //Push new sensor info
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info.push(this.registrationForm.value.sub_device_info[j].sensor_info[k]);
                        let curSensorIndex = this.normalUserDeviceList[i].sub_device_info[e].sensor_info.length - 1;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].id = 0;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensor_index = k;
                        this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].isRemoveSensor = false;
                        // push  Sensor Name
                        if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                          for (var x = 0; x < this.sensorDataList.length; x++) {
                            if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                              this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.sensorDataList[x].sensor_name;
                            }
                          }
                        } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                          for (var x = 0; x < this.DGDataList.length; x++) {
                            if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                              this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.DGDataList[x].sensor_name;
                              
                            }
                          }
                        }
                        // for (var x = 0; x < this.sensorDataList.length; x++) {
                        //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                        //     this.normalUserDeviceList[i].sub_device_info[e].sensor_info[curSensorIndex].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                        //   }
                        // }
                      }
                    }
                  }
                }
              } else {  //Push new subdevice into device
                this.normalUserDeviceList[i].sub_device_info.push(this.registrationForm.value.sub_device_info[j]);
                let curIndex = this.normalUserDeviceList[i].sub_device_info.length - 1;
                this.normalUserDeviceList[i].sub_device_info[curIndex].id = 0;
                this.normalUserDeviceList[i].sub_device_info[curIndex].subdevice_index = j;
                this.normalUserDeviceList[i].sub_device_info[curIndex].isRemoveSubDevice = false;
                // push Inverter Name
                for (var y = 0; y < this.subDevice.length; y++) {
                  if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                  }
                }
                // push model name
                for (var z = 0; z < this.subDevice.length; z++) {
                  if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                  }
                }
                // push meter slug
                for (var s = 0; s < this.meterType.length; s++) {
                  if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                  }
                }
                 //push dg rating
                //  for (var y = 0; y < this.subDevice.length; y++) {
                //   if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                //     this.normalUserDeviceList[i].sub_device_info[curIndex].dg_rating = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).dg_rating;
                //   }
                // }
                // push meter name
                for (var q = 0; q < this.meterType.length; q++) {
                  if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].name) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].name).name;
                  }
                }

                for (var k = 0; k < this.normalUserDeviceList[i].sub_device_info[j].sensor_info.length; k++) {
                  // push new sensor
                  if (this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].id == null) {
                    this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].id = 0;
                    this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensor_index = k;
                    this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].isRemoveSensor = false;
                    // push sensor name
                    if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                      for (var x = 0; x < this.sensorDataList.length; x++) {
                        if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                          this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.sensorDataList[x].sensor_name;
                        }
                      }
                    } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                      for (var x = 0; x < this.DGDataList.length; x++) {
                        if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                          this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.DGDataList[x].sensor_name;
                          
                        }
                      }
                    }
                    // for (var x = 0; x < this.sensorDataList.length; x++) {
                    //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                    //     this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                    //   }
                    // }
                  }
                }
                // push model name
                for (var z = 0; z < this.subDevice.length; z++) {
                  if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    this.normalUserDeviceList[i].sub_device_info[curIndex].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                  }
                }
              }
            }
          }
        }
        length = this.subDeviceList.length
        for (let i = length - 1; i >= 0; i--) {
          this.subDeviceList.removeAt(i)
        }
        this.isSelected = false;
        this.isNewDevice = false;
        this.registrationForm.reset();
        // end allready exist divice
      } else { //Push new device
        for (let index = 0; index < this.devices.length; index++) {
          const device_id = this.devices[index].device_id;
          if (device_id == this.registrationForm.value.device_id) {
            this.demo = this.devices[index].dev_name;
            this.normalUserDeviceList.push(this.registrationForm.value);
            this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).dev_name = this.demo;
            this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).isNewDevice = this.isNewDevice;
            if (this.isNewDevice == true) {
              this.normalUserDeviceList.find(x => x.device_id == this.registrationForm.value.device_id).isRemoveDevice = false;
            }
            for (var i = 0; i < this.normalUserDeviceList.length; i++) {
              if (this.normalUserDeviceList[i].device_id == this.registrationForm.value.device_id) {
                for (var j = 0; j < this.normalUserDeviceList[i].sub_device_info.length; j++) {
                  if (this.normalUserDeviceList[i].sub_device_info[j].id == null) {
                    this.normalUserDeviceList[i].sub_device_info[j].id = 0;
                    this.normalUserDeviceList[i].sub_device_info[j].isRemoveSubDevice = false;
                    this.normalUserDeviceList[i].sub_device_info[j].subdevice_index = j;
                    // push Inverter Name
                    for (var y = 0; y < this.subDevice.length; y++) {
                      if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].sub_device_name = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).name;
                      }
                    }
                    // push meter slug
                    for (var s = 0; s < this.meterType.length; s++) {
                      if (this.meterType[s].id == this.registrationForm.value.sub_device_info[j].meter_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].meter_slug = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].meter_type_id).meter_slug;
                      }
                    }
                    for (var q = 0; q < this.meterType.length; q++) {
                      if (this.meterType[q].id == this.registrationForm.value.sub_device_info[j].name) {
                        this.normalUserDeviceList[i].sub_device_info[j].name = this.meterType.find(x => x.id == this.registrationForm.value.sub_device_info[j].name).name;
                      }
                    }
                    //  push model Name
                    for (var z = 0; z < this.subDevice.length; z++) {
                      if (this.subDevice[z].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                        this.normalUserDeviceList[i].sub_device_info[j].model_name = this.subDevice[z].model_info.find(x => x.model_id == this.registrationForm.value.sub_device_info[j].model_id).model_name;
                      }
                    }
                     //push dg rating
                    //  for (var y = 0; y < this.subDevice.length; y++) {
                    //   if (this.subDevice[y].sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id) {
                    //     this.normalUserDeviceList[i].sub_device_info[j].dg_rating = this.subDevice.find(x => x.sub_device_type_id == this.registrationForm.value.sub_device_info[j].sub_device_type_id).dg_rating;
                    //   }
                    // }
                  }

                  for (var k = 0; k < this.normalUserDeviceList[i].sub_device_info[j].sensor_info.length; k++) {
                    if (this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].id == null) {
                      this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].id = 0;
                      this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensor_index = k;
                      this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].isRemoveSensor = false;
                    }
                    // push sensor name
                    if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '2'){
                      for (var x = 0; x < this.sensorDataList.length; x++) {
                        if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                          this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.sensorDataList[x].sensor_name;
                        }
                      }
                    } else if(this.registrationForm.value.sub_device_info[j].sub_device_type_id == '5'){
                      for (var x = 0; x < this.DGDataList.length; x++) {
                        if (this.DGDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                          this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.DGDataList[x].sensor_name;
                          
                        }
                      }
                    }
                    // for (var x = 0; x < this.sensorDataList.length; x++) {
                    //   if (this.sensorDataList[x].id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id) {
                    //     this.normalUserDeviceList[i].sub_device_info[j].sensor_info[k].sensorName = this.sensorDataList.find(x => x.id == this.registrationForm.value.sub_device_info[j].sensor_info[k].sensor_id).sensor_name;
                    //   }
                    // }
                  }
                }
              }
            }
          }
        }

        // remove FormArray Actomaticaly after submit one device and sub devise
        length = this.subDeviceList.length
        for (let i = length - 1; i >= 0; i--) {
          this.subDeviceList.removeAt(i)
        }
        // this.registrationForm.reset();
        this.isNewDevice = false;
        this.isSelected = false;
        this.registrationForm.reset();
      }
      this.sub_device = false
    }
    this.isEditDevice = true;
  }

  removeEditSubDevice(index, device_index) {
    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    var device_id = this.registrationForm.value.device_id;
    var current_sub_device_id = this.subDeviceList.controls[index].value.id;
    var subdevice_index = this.subDeviceList.controls[index].value.subdevice_index;
    //  code for remove already device and sub sevice
    if (this.normalUserDeviceList[device_index] != undefined && this.normalUserDeviceList[device_index].device_id == device_id && this.normalUserDeviceList[device_index].isRemoveDevice == false && this.normalUserDeviceList[device_index].isNewDevice == false) {
      for (let i = 0; this.normalUserDeviceList[device_index].sub_device_info.length; i++) {
        if (this.normalUserDeviceList[device_index].sub_device_info[i].isRemoveSubDevice == false && this.normalUserDeviceList[device_index].sub_device_info[i].id == current_sub_device_id && this.normalUserDeviceList[device_index].sub_device_info[i].id != 0) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            if (this.normalUserDeviceList[device_index].sub_device_info[i].id == current_sub_device_id) {
              this.normalUserDeviceList[device_index].sub_device_info[i].isRemoveSubDevice = true;
              this.subDeviceList.removeAt(index);
              break;
            }
          } else {
            if (this.normalUserDeviceList[device_index].device_id == device_id) {
              this.normalUserDeviceList[device_index].isRemoveDevice = true;
              this.subDeviceList.removeAt(index);
              this.EditCancel();
              break;
            }
          }
        } else if (this.normalUserDeviceList[device_index].sub_device_info[i].id == 0) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            if (this.normalUserDeviceList[device_index].sub_device_info[i].subdevice_index == this.subDeviceList.controls[index].value.subdevice_index) {
              this.normalUserDeviceList[device_index].sub_device_info.splice(i, 1);
              this.subDeviceList.removeAt(index);
              break;
            }
          } else {
            this.normalUserDeviceList[device_index].isRemoveDevice = true;
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          }
        } else if (this.subDeviceList.controls[index].value.id == null) {
          let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
          if (tempArray.length > 1) {
            this.subDeviceList.removeAt(index);
            break;
          } else {
            this.subDeviceList.removeAt(index);
            this.normalUserDeviceList[device_index].isRemoveDevice = true
            this.EditCancel();
            break;
          }
        }
      }
    } else if (this.normalUserDeviceList[device_index] != undefined && device_index != null && this.normalUserDeviceList[device_index].isNewDevice == true) {
      //  code for remove new device and sub sevice
      let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
      if (tempArray.length > 1) {
        for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info.length; j++) {
          if (this.normalUserDeviceList[device_index].sub_device_info[j].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[j].subdevice_index == subdevice_index) {
            this.normalUserDeviceList[device_index].sub_device_info.splice(j, 1);
            this.subDeviceList.removeAt(index);
            break;
          } else if (this.subDeviceList.controls[index].value.id == null) {
            this.subDeviceList.removeAt(index);
            break;
          }
        }
      } else {
        for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info.length; j++) {
          if (this.normalUserDeviceList[device_index].sub_device_info[j].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[j].subdevice_index == subdevice_index) {
            this.normalUserDeviceList[device_index].sub_device_info.splice(j, 1);
            this.normalUserDeviceList.splice(device_index, 1);
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          } else if (this.subDeviceList.controls[index].value.id == null) {
            this.normalUserDeviceList.splice(device_index, 1);
            this.subDeviceList.removeAt(index);
            this.EditCancel();
            break;
          }
        }
      }
    }
    else {
      // let tempArray = this.subDeviceList.value.filter(x => x.isRemoveSubDevice != true)
      if (this.subDeviceList.length > 1) {
        this.subDeviceList.removeAt(index);
      } else {
        this.subDeviceList.removeAt(index);
        this.EditCancel();
      }
    }

    console.log("remmove sub devicle");
    console.log(this.subDeviceList)

  }


  removeSensor(control, sensorIndex, subDeviceIndex, device_index) {
    // console.log(this.registrationForm.get('sub_device_info'));
    // console.log(control);

    this.subDeviceList = this.registrationForm.controls.sub_device_info as FormArray;
    var current_sub_device_id = this.subDeviceList.controls[subDeviceIndex].value.id;
    var device_id = this.registrationForm.value.device_id;
    //  code for remove already device and sub sevice
    if (this.normalUserDeviceList[device_index] != undefined && this.normalUserDeviceList[device_index].isNewDevice == false && this.normalUserDeviceList[device_index].device_id == device_id && this.normalUserDeviceList[device_index].isRemoveDevice == false) {

      for (let k = 0; k < this.normalUserDeviceList[device_index].sub_device_info.length; k++) {
        if (this.normalUserDeviceList[device_index].sub_device_info[k].id == current_sub_device_id && this.normalUserDeviceList[device_index].sub_device_info[k].id != 0 && current_sub_device_id != null) {
          if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length != 0) {
            for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length; j++) {
              console.log('i am in sensor for loop');
              if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].id == control.value[sensorIndex].id && control.value[sensorIndex].id != 0 && control.value[sensorIndex].id != null) {
                console.log('i am in old sensor ');
                this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].isRemoveSensor = true;
                control.removeAt(sensorIndex);
                break;
              } else if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].id == control.value[sensorIndex].id && control.value[sensorIndex].id == 0 && control.value[sensorIndex].id != null) {
                console.log('i am in new sensor ');
                if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].sensor_index == control.value[sensorIndex].sensor_index) {
                  this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.splice(j, 1);
                  control.removeAt(sensorIndex);
                  break;
                }
                // break;
              }
              else if (control.value[sensorIndex].id == null) {
                console.log('i am in null sensor ');
                control.removeAt(sensorIndex);
                break;
              }
            }
          } else {
            control.removeAt(sensorIndex);
          }
          break;
        } else if (this.normalUserDeviceList[device_index].sub_device_info[k].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[k].subdevice_index == this.subDeviceList.controls[subDeviceIndex].value.subdevice_index) {
          if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length != 0) {
            for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length; j++) {
              if (control.value[sensorIndex].id != null && control.value[sensorIndex].id == 0 && control.value[sensorIndex].sensor_index == this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].sensor_index) {
                this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.splice(j, 1);
                control.removeAt(sensorIndex);
                break;
              } else if (control.value[sensorIndex].id != 0 && control.value[sensorIndex].id == null) {
                control.removeAt(sensorIndex);
                break;
              }
            }
          } else {
            control.removeAt(sensorIndex);
          }
          break;
        } else if (current_sub_device_id == null) {
          control.removeAt(sensorIndex);
          break;
        }
      }
    } else if (this.normalUserDeviceList[device_index] != undefined && this.normalUserDeviceList[device_index].device_id == device_id && this.normalUserDeviceList[device_index].isNewDevice == true) {
      for (let k = 0; k < this.normalUserDeviceList[device_index].sub_device_info.length; k++) {
        if (this.normalUserDeviceList[device_index].sub_device_info[k].id == 0 && this.normalUserDeviceList[device_index].sub_device_info[k].subdevice_index == this.subDeviceList.controls[subDeviceIndex].value.subdevice_index && current_sub_device_id != null) {
          if (this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length != 0) {
            for (let j = 0; j < this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.length; j++) {
              if (control.value[sensorIndex].id == 0 && control.value[sensorIndex].sensor_index == this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].sensor_index && this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info[j].id == control.value[sensorIndex].id && control.value[sensorIndex].id != null) {

                this.normalUserDeviceList[device_index].sub_device_info[k].sensor_info.splice(j, 1);
                control.removeAt(sensorIndex);
                break;
              } else if (control.value[sensorIndex].id == null && control.value[sensorIndex].id != 0) {
                control.removeAt(sensorIndex);
                break;
              }
            }
          } else {
            control.removeAt(sensorIndex);
          }
          break;
        } else if (current_sub_device_id == null) {
          control.removeAt(sensorIndex);
          break;
        }
      }
    } else {
      control.removeAt(sensorIndex);
    }
  }

  filterItemsOfType(type) {
    return type.filter(x => x.isRemoveSubDevice == false);
  }
  filtersensor(type) {
    return type.filter(x => x.isRemoveSensor != true);
  }
  // findLastIndex(type){
  //   console.log(type.controls);
  //   // type.value.LastIndexOf(x => x.isRemoveSensor != true);
  // }
  ngOnDestroy() {


    this.ResponseVerifiedGetAllSubDevice.next();
    this.ResponseVerifiedGetAllSubDevice.complete();
    this.ResponseVerifiedGetAllEnergyMeter.next();
    this.ResponseVerifiedGetAllEnergyMeter.complete();


  }

  checkArray(id) {
    let flag = this.normalUserDeviceList.find(x => x.device_id == id);
    return flag;
  }

  //get all meter type
  getAllMeterType() {

    this.dasbordService.getAllMeterTypeByAdmin()
      .pipe(takeUntil(this.ResponseVerifiedGetAllEnergyMeter))
      .subscribe(
        async data => {
          this.meterType = data.resultObject;

          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.success(data.message);
            this.router.navigate(["/login"]);
          }
          else if (!data.status) {
            this.toastr.success(data.message);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  onChangeMeterType(value) {
    this.meter_type_Id = value
  }

}


